import TechnologyDetailPage from "@/pages/technologies/components/TechnologyDetailPage";

export default function LaravelTechPage() {
  return <TechnologyDetailPage slug="laravel" />;
}